module.exports = __webpack_public_path__ + "static/img/office-slide-1.bef511f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/office-slide-1.png
// module id = 28Fz
// module chunks = 0